<template>

  <div class="list--view">    
    <div class="single--list-view single--list-view-employees">
      <vs-select
          class="selectExample"
          v-model="selectTypeRoles"
          @input="statusSelected"
      >
        <vs-select-item
            :is-selected="item.isSelected"
            :key="index"
            :value="item.value"
            :text="item.label"
            v-for="(item,index) in optionsTypeRoles" />
      </vs-select>
    </div>

    <div class="single--list-view single--list-view-roles">
      <vs-select
          class="selectExample"
          v-model="selectTypeRole"
          @input="typologySelected"

      >
        <vs-select-item
            :is-selected="item.isSelected"
            :key="index"
            :value="item.value"
            :text="item.label"
            v-for="(item,index) in optionsTypeRole" />
      </vs-select>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      selectTypeRoles: (location.search.indexOf("closed") >= 0 && /closed=([^&]+)/.exec(location.href)[1] === "true") ? "hystorical" : "actual",
      selectTypeRole: /roles_set=([^&]+)/.exec(location.href) == null ? "" : /roles_set=([^&]+)/.exec(location.href)[1],

      optionsTypeRoles:[
        {value: 'actual', label:this.__('misc.actuals'), isSelected: false },
        {value: 'hystorical', label:this.__('misc.history'), isSelected: false },
      ],
      optionsTypeRole:[],


    }
  },
  methods: {
    statusSelected(selectedOption, id) {
      if (selectedOption == "actual") {
        location.href = app.__vue__.addParam("closed", "false");
      } else if (selectedOption == "hystorical") {
        location.href = app.__vue__.addParam("closed", "true");
      }
    },
    typologySelected(selectedOption, id) {

      if(selectedOption===''){
        location.href = "/roles";
      }
      else {
        location.href = app.__vue__.addParam('roles_set', selectedOption);
      }
    },
    loadTypologies(){

      axios
          .get("/getRolesSet")
          .then(response => {
            this.datas = response.data;
            this.optionsTypeRole=this.datas;
          });
    }
  },
  mounted(){
    this.loadTypologies()

  }
}
</script>
